import*as l from"react";function e(e,a){var i,n;return l.isValidElement(e)&&-1!==a.indexOf(null!=(i=e.type.muiName)?i:null==(n=e.type)||null==(n=n._payload)||null==(n=n.value)?void 0:n.muiName)}export{e as i};
